import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { withTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  root: {
    position: 'absolute',
    left: 10,
    bottom: 20,
    zIndex: 1,
    display: 'flex',
    gap: 8,
  },
  paper: {
    borderRadius: 2,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10,
  },
  photoPaper: {
    borderRadius: 2,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    background: 'linear-gradient(135deg, #ed1e79 0%, #29abe2 100%)',
    '& .MuiFormControlLabel-label': {
      color: '#fff',
      fontWeight: 'bold',
    },
    '& .MuiCheckbox-root': {
      color: '#fff',
      '&.Mui-checked': {
        color: '#fff',
      },
    },
  }
};

class FilterButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const { classes, t, showOnlyColorPrinters, showOnlyPhotoPrinters, hasPhotoPrinters, showPhoto = true, showDocument = true } = this.props;

    // Show color checkbox if showDocument is true
    const showColorCheckbox = showDocument;
    // Show photo checkbox only if showDocument is true AND showPhoto is true AND there are photo printers
    const showPhotoCheckbox = showDocument && showPhoto && hasPhotoPrinters;

    // Don't render if no checkboxes should be shown
    if (!showColorCheckbox && !showPhotoCheckbox) {
      return null;
    }

    return (
      <div className={classes.root}>
        {showColorCheckbox && (
          <Paper className={classes.paper} elevation={1}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => showOnlyColorPrinters(e.target.checked)}
                />
              }
              label={t('colorFilter')}
            />
          </Paper>
        )}
        {showPhotoCheckbox && (
          <Paper className={classes.photoPaper} elevation={1}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => showOnlyPhotoPrinters(e.target.checked)}
                />
              }
              label={t('photoFilter')}
            />
          </Paper>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(FilterButton));
